export interface DropdownViewport {
  readonly top: number
  readonly left: number
  readonly height: number
  readonly width: number
  readonly layoutHeight?: number
}

/** 13265139932: prefer useful space below; never extend beyond the visible viewport. */
export const webProductDropdownGeometry = (
  rect: { top: number; left: number; width: number; height: number },
  viewport: DropdownViewport,
) => {
  const margin = 8
  const topEdge = viewport.top + margin
  const bottomEdge = viewport.top + viewport.height - margin
  const bottom = Math.max(topEdge, Math.min(rect.top + rect.height, bottomEdge))
  const top = Math.max(topEdge, Math.min(rect.top, bottomEdge))
  const below = Math.max(0, bottomEdge - bottom)
  const above = Math.max(0, top - topEdge)
  const preferredHeight = Math.max(0, viewport.height * 0.4)
  const opensBelow = below >= Math.min(144, preferredHeight) || below >= above
  const maxHeight = Math.min(preferredHeight, opensBelow ? below : above)
  const width = Math.min(rect.width, Math.max(0, viewport.width - margin * 2))
  const left = Math.max(
    viewport.left + margin,
    Math.min(rect.left, viewport.left + viewport.width - margin - width),
  )
  return {
    left,
    width,
    maxHeight,
    top: opensBelow ? bottom : undefined,
    bottom: opensBelow
      ? undefined
      : (viewport.layoutHeight ?? viewport.top + viewport.height) - top,
  }
}
